import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { Button } from "../../stories/Buttons/Button";
import { BoxArrowInRight } from "react-bootstrap-icons";
import { ReactComponent as logout } from "../../assets/icons/logout.svg";
import useApis from "../../services/useAPI";
import { useAuth } from "../../components/AuthContext/AuthContext";
import { logoutUrl, cookieExpirationTime } from "../../utils/constants";
import ConfirmationModal from "../../stories/Modal/ConfirmationModal";
import PropTypes from "prop-types";

/**
 * Handles Logout functionality.
 * Calls logout API and clears local storage
 * Renders either a button or an icon based on isMobileView
 * @param {Object} props - Component props
 * @param {boolean} props.isMobileView - Indicates if the view is mobile
 * @returns {JSX.Element} Logout component
 */
function Logout({ isMobileView }) {
  const auth = useAuth();
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const { callApi } = useApis(logoutUrl, "POST");

  const handleClick = async () => {
    await callApi();
    auth.setIsAuthenticated(false);

    // Clear next URL to prevent redirecting to the previous user's pages
    auth.setNextURl("");

    localStorage.clear();
    sessionStorage.clear();
    const cookies = document.cookie.split(";");
    cookies.forEach((cookie) => {
      const cookieName = cookie.split("=")[0].trim();
      document.cookie = `${cookieName + cookieExpirationTime}`;
    });
    
    navigate("/login");
    auth?.showToast(
      "Logged out",
      "Logged out successfully!",
      "../assets/mhc.png",
      <BoxArrowInRight />,
    );
  };

  const handleModalClose = () => {
    setModalShow(false);
  };

  const handleModalConfirm = async () => {
    setModalShow(false);
    await handleClick();
  };

  const Icon = logout;

  return (
    <>
      {isMobileView ? (
        <button onClick={() => setModalShow(true)} className="log-out-icon">
          {logout && <Icon width={35} height={35} className="icon" />}
        </button>
      ) : (
        <Container className="text-center p-0">
          <Button
            label="Log out"
            onClick={() => {
              setModalShow(true);
            }}
            className="logout-button btn"
          />
        </Container>
      )}
      <ConfirmationModal
        heading={""}
        handleClose={handleModalClose}
        handleConfirm={handleModalConfirm}
        labelOne={"Cancel"}
        labelTwo={"Log out"}
        message="Are you sure you want to log out?"
        show={modalShow}
        vairantOne={"danger"}
        variantTwo={"primary"}
      />
    </>
  );
}

Logout.propTypes = {
  isMobileView: PropTypes.bool.isRequired,
};

export default Logout;
